module.exports = __webpack_public_path__ + "static/media/open_house.18f69717.jpg";